import React from 'react';
import DialogTitle from '../../DialogTitle';
import { Controller, useFormContext } from 'react-hook-form';
import FileDropBox from '../../../ui/FileDropBox/FileDropBox';
import { IonicButton } from 'ionic-ui';
import { editProductSchema } from '../../../../schemas/newProductSchema';
import z from 'zod';
import ResponsiveImage from '../../../responsive-image/ResponsiveImage';

type Props = {
  onNext: () => void;
  onImageRemoval: (imageId: number) => void;
};

export default function StepTwo({ onNext, onImageRemoval }: Props) {
  const { control, watch } =
    useFormContext<z.infer<typeof editProductSchema>>();
  const images = watch('existing_images');

  return (
    <div className="sm:w-[55vw] max-xlg:w-[660px] dialog-content space-y-4">
      <DialogTitle>You can upload a maximum of 4 images</DialogTitle>
      <label className="medium-emphasis-text">
        Please upload a maximum of 4 images
      </label>
      <div className="w-full gap-4 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 items-start py-4">
        {images?.map(({ file_url, id }) => (
          <div className="space-y-2 border border-border p-2 rounded-md min-w-fit">
            <ResponsiveImage
              aspectRatio={1}
              className="rounded-sm"
              src={file_url}
              key={id}
            />
            <IonicButton
              variant="outline"
              type="button"
              className="w-full round-sm text-nowrap"
              onClick={() => onImageRemoval(id)}
            >
              Remove
            </IonicButton>
          </div>
        ))}
      </div>
      {/* PRODUCT IMAGES */}
      {images?.length < 4 && (
        <Controller
          name="new_images"
          control={control}
          render={({ field, fieldState }) => (
            <>
              <FileDropBox
                {...field}
                acceptedTypes={{
                  'image/jpeg': ['.jpg', '.jpeg'],
                  'image/png': ['.png'],
                  'image/svg+xml': ['.svg'],
                }}
                onChange={(value) => {
                  //SINCE fileDropBox CAN RETURN ARRAY OR A SINGLE FILE DEPENDING ON THE MAX
                  if (Array.isArray(value)) return field.onChange(value);
                  field.onChange([value]);
                }}
                allowCropping
                cropperAspectRatio={1 / 1}
                warning="Upload up to 4 high-quality images (Max 500KB each)"
                maxFiles={4 - images?.length}
                errorMessage={fieldState.error?.message}
              />
            </>
          )}
        />
      )}

      <div className="grid grid-cols-2 w-full sm:grid-cols-3 [direction:rtl]">
        <IonicButton type="button" onClick={onNext}>
          Submit
        </IonicButton>
      </div>
    </div>
  );
}
